import { app } from '../../../../../../app';
import { Controller } from './copy-accounts-to-groups.controller';

app.component('companyUserDirectoriesManageGroupAccountsCopy', {
    bindings: {
        accounts: '<',
        companyId: '<',
        groups: '<',
    },
    controller: Controller,
    templateUrl: require('./copy-accounts-to-groups.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/manage-group/accounts/copy/copy-accounts-to-groups.component.js